import { ITransferRequest } from './../../../_models/transfer-sections/ITransferRequest';
import { TransferRequestService } from './../../../shared/services/transfer-request.service';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-transfer-request-unlock',
  templateUrl: './transfer-request-unlock.component.html',
  styleUrls: ['./transfer-request-unlock.component.css']
})
export class TransferRequestUnlockComponent implements OnInit {
  skeleton: boolean = true;
  transferRequest: ITransferRequest;

  constructor(
    private service: TransferRequestService,
    private toastrService: ToastrService,
    private router: Router,) { }

  ngOnInit(): void {
    this.getTransferRequest();
  }

  getTransferRequest() {
    this.service.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        this.transferRequest = response;
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }

  unconfirm() {
    if (!confirm('Are you sure you want to unlock this application?')) return;

    this.service.unconfirm().subscribe(() => {
      this.toastrService.success('application unlocked successfully.');
      this.router.navigate(['/employee']);
    });
  }
}
